"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetApolloClient = void 0;
var use_get_apollo_client_hook_1 = require("./use-get-apollo-client.hook");
Object.defineProperty(exports, "useGetApolloClient", { enumerable: true, get: function () { return use_get_apollo_client_hook_1.useGetApolloClient; } });
